module.exports = __webpack_public_path__ + "img/oled.2e78a18b.png";